import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import '../scss/index.scss';
import '../../scss/explain.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moSalaryCity from './store';
import PDF from '../../../component/pdf';
import Title from '../../../component/title';
import HeadPdf from '../../../component/head-pdf';
import FootPdf from '../../../component/foot-pdf';
import moIndex from '../../../store/index';

interface IProps {}
interface IState {}

const ExplainPDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const { xData, overview } = moSalaryCity;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <>
      {xData.length > 0 ? (
        <PDF>
          <section className="salary-up-pdf_1010">
            <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
            <section className="content-salary-1001">
              <section className="title-1001">
                <Title title="涨薪率 - 按行业" bigTitle="人力指标" tag={industry.name} />
              </section>

              <section className="box-15050">
                <strong>解读：</strong>
                <section className="box-151">
                  {overview?.map((text: any, index: number) => (
                    <p key={index}>
                      <span className="ico-11"><b /></span>
                      <i>{text}</i>
                    </p>
                  ))}
                </section>
              </section>
            </section>
            <FootPdf />
          </section>
        </PDF>
      ) : null}
    </>
  );
};

export default observer(ExplainPDF);
